import { parseRangeHeader } from "@robe/core-api/content/utils/pagination";
import { SearchSupportFilesOptions } from "./options";
import { RobeSupportFilesGroups } from "./RobeSupportFilesGroups";
import { RobeSupportFilesMedia } from "./RobeSupportFilesMedia";
import { RobeSupportFilesPermissions } from "./RobeSupportFilesPermissions";
import { RobeSupportFilesUsers } from "./RobeSupportFilesUsers";
import { parseQueryParamsObject } from "@robe/core-utils";
import { XcoreCore } from "XcoreCore";

export class RobeSupportFiles {
  private core: XcoreCore;

  public readonly groups: RobeSupportFilesGroups;
  public readonly users: RobeSupportFilesUsers;
  public readonly media: RobeSupportFilesMedia;
  public readonly permissions: RobeSupportFilesPermissions;

  constructor(core: XcoreCore) {
    this.core = core;

    this.groups = new RobeSupportFilesGroups(core);
    this.users = new RobeSupportFilesUsers(core);
    this.media = new RobeSupportFilesMedia(core);
    this.permissions = new RobeSupportFilesPermissions(core);
  }

  public search(term: string, { product, category, page }: SearchSupportFilesOptions) {
    return this.core
      .fetch(`/api/support-files${parseQueryParamsObject({ term, contents: product, categories: category, page })}`)
      .then(async (res) => {
        const supportFiles = await res.json();

        return {
          supportFiles,
          pagination: {
            ...parseRangeHeader(res.headers.get("content-range")!),
            perPage: 50,
          },
        };
      });
  }
}
